import { Label } from "evergreen-ui";
import React from "react";
import styled from "styled-components";

const Container = styled.div<any>`
  display: flex;
  width: 100%;
  height: ${(props) => props.height};
  align-items: center;
  justify-content: center;
`;

interface IProps {
  height?: string | undefined | null;
  label?: string | undefined | null;
}
const Message: React.SFC<IProps> = ({
  height = "50vh",
  label = "No record found",
}) => {
  return (
    <Container height={height}>
      <Label>{label}</Label>
    </Container>
  );
};

export default Message;
